export default __webpack_public_path__ + "static/media/error.3a5bee18.jpg";